var router = require('pjax').Router;
var form = require('./form.js');
var formRandom = require('./form-random.js');
var index = require('./index.js');

router.get('assignment', index);
router.get('assignment/new', form);
router.get('assignment/new-random', formRandom);
